import { add, formatDistanceStrict } from 'date-fns';

export function lengthFromDays(num: number | undefined) {
  const start = new Date(0);
  const base2 = new Date(0);
  const end = add(base2, { days: num });

  return formatDistanceStrict(end, start);
}
